import * as yup from 'yup'

const individualWithProfessionValidationSchema = yup.object().shape({
    civility: yup
        .string()
        .required("La civilité est requise"),
    lastName: yup
        .string()
        .required("Le nom est requis"),
    firstName: yup
        .string()
        .required("Le prénom est requis"),
    profession: yup
        .string()
        .required("La profession est requise"),
    nationality: yup
        .string()
        .required("La nationalité est requise")

})

export default individualWithProfessionValidationSchema